

































import { Vue, Component } from 'vue-property-decorator';
import CardTitle from '@/shared/card/card-title.component.vue';
import Loading from '@/shared/loading/loading.component.vue';
import NotFoundComponent from '@/shared/not-found/not-found.component.vue';
import SelectLanguageComponent from '@/views/survey/select-language.component.vue';
import Assessment from '@/domain/assessment/entity/assessment';
import PdiService from '@/domain/pdi/pdi.service';
import Priority from '@/domain/activity/entity/priority.entity';
import AssessmentSimulationSimple from '@/domain/assessment/entity/assessment-simulation-list.entity';
import ModalComponent from '@/shared/modal/modal.component.vue';
import AssignmentSingleFilter from '@/shared/filters/assignment/assignment-single-filter.component.vue';
import Rules from '@/shared/rules/rules';
import Level from '@/domain/assessment/entity/assignment/level';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import EmployeeService from '@/domain/employees/service/employee.service';
import AssessmentResultPercentItem from '../components/assessment-result-percent-item.component.vue';
import AssessmentResultPercentGraph from '../components/assessment-result-percent-graph.component.vue';
import AssessmentItemComponent from './assessment-item.component.vue';
import CurrentAssessmentTabComponent from './current-assessment-tab.component.vue';
import AssessmentComponent from './assessment.component.vue';
import AssessmentSimulationTabComponent from './assessment-simulation-tab.component.vue';

@Component({
  components: {
    CardTitle,
    Loading,
    NotFoundComponent,
    SelectLanguageComponent,
    AssessmentResultPercentItem,
    AssessmentResultPercentGraph,
    AssessmentItemComponent,
    CurrentAssessmentTabComponent,
    ModalComponent,
    AssignmentSingleFilter,
    LabelSlot,
    AssessmentComponent,
    AssessmentSimulationTabComponent,
  },
})
class EmployeeAssessmentResultView extends Vue {
  value: number = 80;

  employeeId: string = this.$route.params.employeeId;

  loading: boolean = false;

  selected: boolean = false;

  languages = [
    {
      text: 'Brasil - pt-br',
      acronym: 'PT_BR',
      acronymFlag: 'BRA',
    },
    {
      text: 'Espanhol - es',
      acronym: 'ES',
      acronymFlag: 'ES',
    },
    {
      text: 'English - en',
      acronym: 'EN',
      acronymFlag: 'US',
    },
  ];

  languageSelectedAcronym: string = 'PT_BR';

  assessment: Assessment = new Assessment();

  isEditMode: boolean = false;

  loadingSave: boolean = false;

  priorityItems: Priority[] = [];

  simulations: AssessmentSimulationSimple[] = [];

  openNewSimulationModal: boolean = false;

  assignmentIdSelected: string = '';

  levelSimulationId: string = '';

  rules: Rules = new Rules();

  levels: Level[] = [];

  loadingLevels: boolean = false;

  simulation: Assessment | null = null;

  loadingStartSimulation: boolean = false;

  userLoggedId: string = '';

  created() {
    this.$destroy();
    this.getAllPriority();
    this.getUserLogged();
  }

  getAllPriority() {
    PdiService.getAllPriority().then(response => this.priorityItems = response);
  }

  async getUserLogged(): Promise<void> {
    this.userLoggedId = await EmployeeService.getLoggedUserEmployeeId();
  }

  get isUserLoggedIn(): boolean {
    return this.userLoggedId === this.employeeId;
  }
}

export default EmployeeAssessmentResultView
